import { usePaymentTerminalContext } from "contexts/PaymentTerminalContext";

import { PaymentTerminalSelectProps } from "./types";

import PaymentTerminalSelect from ".";

const PaymentTerminalContextSelect: React.FC<
  Omit<PaymentTerminalSelectProps, "value" | "onChange">
> = (props) => {
  const { paymentTerminal: value, setPaymentTerminal: onChange } =
    usePaymentTerminalContext();

  return (
    <PaymentTerminalSelect
      {...{
        ...props,
        value,
        onChange,
      }}
    />
  );
};

export default PaymentTerminalContextSelect;
